<ng-select #organizationsSelect
           bindLabel="name"
           [items]="(organizations$ | async) ?? []"
           [typeahead]="organizationsSearchInput$"
           [minTermLength]="minSearchTermLength"
           [placeholder]="placeholder"
           [loading]="organizationsLoading"
           [clearable]="true"
           [virtualScroll]="false"
           [ngStyle]="{'width': '100%'}"
           [readonly]="readOnly"
           (change)="onOrganizationChange($event)"
           (search)="onSearchTermChange($event)"
           (clear)="resetCurrentSearch()"
           class="default-style magnifier">
  <ng-template ng-header-tmp>
    <div class="row d-flex flex-row">
      <div class="col-4">
        <div><strong>Firm</strong></div>
      </div>
      <div class="col-4">
        <div><strong>URL</strong>
        </div>
      </div>
      <div class="col-4">
        <div><strong>FGI</strong></div>
      </div>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div class="row d-flex flex-row">
      <div class="col-4">
        <div [innerHTML]="item.name | formatSearchTermPipe: currentSearchTerm"></div>
      </div>
      <div class="col-4">
        <div [innerHTML]="item.urlPrefix | formatSearchTermPipe: currentSearchTerm"></div>
      </div>
      <div class="col-4">
        <div [innerHTML]="item.globalIdentifier | formatSearchTermPipe: currentSearchTerm"></div>
      </div>
    </div>
  </ng-template>
  <ng-template ng-footer-tmp *ngIf="morePages">
    <p class="placeholder-color">There are more results based on your search. Type more characters to refine search.</p>
  </ng-template>
</ng-select>


